import { Models } from "@grandvisionhq/carts-v2";
import { getCheckoutState } from "../../../api/pages/api/get-checkout-state.js";
import { recoverCheckout } from "../../../api/pages/api/recover-checkout.js";
const validateCheckoutRoute = async ({
  apolloClient,
  cartHash,
  cartId,
  type,
  pathname
}) => {
  const validCheckoutResult = {
    isCheckoutValid: true,
    redirectUrl: ""
  };
  try {
    const { checkoutState } = await getCheckoutState(apolloClient, cartId, cartHash);
    if (checkoutState && checkoutState === Models.CheckoutState.Finalized) {
      const recoveredCheckout = await recoverCheckout(apolloClient, cartId);
      if (recoveredCheckout.success) {
        validCheckoutResult.isCheckoutValid = false;
        validCheckoutResult.redirectUrl = `${pathname}?cartId=${recoveredCheckout.cartId}&cartHash=${recoveredCheckout.cartHash}&type=${type || ""}`;
      }
    }
    return validCheckoutResult;
  } catch (error) {
    console.error(error);
    return validCheckoutResult;
  }
};
export {
  validateCheckoutRoute
};
//# sourceMappingURL=validate-checkout-route.js.map
